export enum WastageLogItemType {
  INGREDIENT = 'Ingredient',
  PREP_RECIPE = 'Prep Recipe',
  MAIN_RECIPE = 'Main Recipe',
}

// wastage-reason enum
export enum WastageLogReason {
  EXPIRED = 'Expired',
  SPOILED = 'Spoiled',
  OVERCOOKED = 'Overcooked',
  UNDERCOOKED = 'Undercooked',
  OVER_PREPPED = 'Over-prepped',
  INCORRECT_PORTIONING = 'Incorrect portioning',
  DAMAGED_DURING_STORAGE = 'Damaged during storage',
  CONTAMINATED = 'Contaminated',
  INCORRECT_ORDER_MADE = 'Incorrect order made',
  BURNT = 'Burnt',
  IMPROPERLY_STORED = 'Improperly stored',
  STOLEN = 'Stolen',
  LOST_DURING_HANDLING = 'Lost during handling',
  EXCESS_TRIMMING_CUTTING = 'Excess trimming/cutting',
  OVERESTIMATED_DEMAND = 'Overestimated demand',
  QUALITY_CONTROL_REJECTION = 'Quality control rejection',
  SEASONAL_SURPLUS = 'Seasonal surplus',
  MENU_ITEM_DISCONTINUED = 'Menu item discontinued',
}

export interface GetWastageLogItems {
  id: number;
  name: string;
  quantityOnHand: string;
  parValue: string;
  unitOfMeasurement: string;
}

export interface GetWastageLogItems {
  id: number;
  name: string;
  quantityOnHand: string;
  parValue: string;
  unitOfMeasurement: string;
}

interface ReportedByUser {
  firstName: string;
  lastName: string;
}

interface ReportedBy {
  id: number;
  user: ReportedByUser;
}

interface Recipe {
  name: string;
  recipeType: string;
  unit: {
    id: number;
    abbreviation: string;
  };
}

interface Ingredient {
  name: string;
  unitOfMeasure?: {
    id: number;
    abbreviation: string;
  };
}

export interface GetWastageLogTypes {
  id: number;
  wastedQuantity: number;
  reason: string;
  comments?: string;
  createdAt: Date;
  ingredient: null | Ingredient;
  recipe: Recipe | null;
  reportedBy: ReportedBy;
}
